import { apiClient } from '@/lib/api-client';

/**
 * Live FX rate read - thin wrapper around `GET /currency-conversion/rate`.
 * Server side does the caching (in-process + Redis + provider), so this call
 * is effectively free after the first request per base currency per session.
 */
export interface FxRateResponse {
  from: string;
  to: string;
  rate: number;
}

export async function fetchFxRate(from: string, to: string): Promise<FxRateResponse> {
  const { data } = await apiClient.get<FxRateResponse>('/currency-conversion/rate', {
    params: { from, to },
  });
  return data;
}
